export class ListType {
  static readonly CONTENT = 'content'
  static readonly CERT = 'certificates'
  static readonly CCN = 'clinical-changes'
  static readonly VIDEO = 'video'
  static readonly JOB = 'job'
  static readonly DOCUMENT = 'documents'
}
